module.exports = __webpack_public_path__ + "media/images/best_gm_office2-a9967e41.jpg";